<script setup lang="ts">
import { propTypes } from '@/utils/propTypes';
import { useSlots } from 'vue';

const slots = useSlots()

defineProps({
  titleHeight: propTypes.string.def('48px'),
  title: propTypes.string.def(''),
  titleBorder: propTypes.bool.def(false),
})
const tSlotFlag = !!useSlots().tSlot;
</script>

<template>
  <div class="h-full flex flex-col justify-between text-[var(--c-txt)]">
    <div
      v-if="title||tSlotFlag"
      class="flex items-center justify-between px-[20px]"
      :style="{height: titleHeight, 
        borderBottom:titleBorder?'1px solid #c8c8c8':'none',
      }">
      <span class="font-bold text-[var(--c-txt)] text-[18px]">{{title}}</span>
      <div class="flex items-center gap-[8px]">
        <slot name="tSlot">
        </slot>
      </div>
    </div>
    <div v-if="slots.default" class='flex-1'>
      <slot></slot>
    </div>  
  </div>
</template>

<style lang="less" scoped>
</style>